// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___35AtT","handUp":"handUp___1IXig","hand":"hand___FdVPs","text":"text___l3i4S","isActive":"isActive___3rtT8"};